import { render, staticRenderFns } from "./authFirstLoginSuccess.vue?vue&type=template&id=5990b49d&scoped=true"
import script from "./authFirstLoginSuccess.vue?vue&type=script&lang=js"
export * from "./authFirstLoginSuccess.vue?vue&type=script&lang=js"
import style0 from "./authFirstLoginSuccess.vue?vue&type=style&index=0&id=5990b49d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990b49d",
  null
  
)

export default component.exports